import { Save, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { memo } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  onSave: () => void;
  onClose: () => void;
  isPending: boolean;
};

const CustomPolicyHeader = ({ onSave, onClose, isPending }: Props) => {
  const { t } = useTranslation(["boCustoms", "common"]);
  return (
    <div className="flex items-center justify-between border-b border-gray-200 bg-white px-8 py-4">
      <h1 className="font-jakarta-sans text-lg font-semibold">{t("policyHeader.title")}</h1>
      <div className="flex items-center gap-3">
        <Button type="button" onClick={onSave} disabled={isPending}>
          <Save className="size-4" />
          {isPending ? t("policyHeader.saving") : t("policyHeader.save")}
        </Button>
        <Button type="button" variant="outline" onClick={onClose}>
          <X className="size-4" />
          {t("common:actions.close")}
        </Button>
      </div>
    </div>
  );
};

export const MemoizedCustomPolicyHeader = memo(CustomPolicyHeader, (prevProps, nextProps) => {
  return prevProps.isPending === nextProps.isPending;
});
